// Import styles
import "../assets/scss/default.scss";

/**
 * Formats an amount in euros.
 *
 * The default was `0`, and 37 of the 46 calls did not pass a second
 * argument: in the same column « 49 261,43 € » sat next to « 49 283 € », and
 * a unit price of 40 cents was displayed « 0,4 € ». An amount in euros
 * always has two decimals. No call explicitly asked for `0`, so
 * changing the default takes nothing away from anyone.
 */
// Amounts are written the way the dashboard's language writes them (« 49,00 € », "€49.00"): plugins/locale.js keeps
// this tag in step with it. French until then.
let numberLocale = "fr-FR";
export const setNumberLocale = (tag) => { numberLocale = tag || "fr-FR"; };

const text2Price = (text, minimumDigits = 2) => {
  return Intl.NumberFormat(numberLocale, {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: minimumDigits
  }).format(text);
};
export { text2Price };

const bytesToSize = (bytes) => {
  const sizes = ["Bytes", "Ko", "Mo", "Go", "To"];
  if (bytes === 0) return "0 Byte";
  const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
  return Math.round(bytes / Math.pow(1024, i)) + " " + sizes[i];
};
export { bytesToSize };

/**
 * mm2px - Convert millimeters to pixels
 * @param mm - Millimeters
 * @returns {number} Pixels
 */
const mm2px = (mm) => {
  return mm * 3.7795275590551;
};
export { mm2px };

/**
 * deg2rad - Convert degrees to radians
 * @param {number} deg - Degrees
 * @return {number} Radians
 */
const deg2rad = (deg) => {
  return deg * (Math.PI / 180);
};
export { deg2rad };

/**
 * rad2deg - Convert radians to degrees
 * @param {number} rad - Radians
 * @return {number} Degrees
 */
const rad2deg = (rad) => {
  return rad * (180 / Math.PI);
};
export { rad2deg };

const raw2base64 = (raw) => {
  return btoa(new Uint8Array(raw).reduce((data, byte) => data + String.fromCharCode(byte), ""));
};
export { raw2base64 };

const textToSha256 = (string) => {
  const utf8 = new TextEncoder().encode(string);
  return crypto.subtle.digest('SHA-256', utf8).then((hashBuffer) => {
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hashHex = hashArray
      .map((bytes) => bytes.toString(16).padStart(2, '0'))
      .join('');
    return hashHex;
  });
};

export { textToSha256 };

const truncate = (text, maxLength, end = "") => {
  return text.length > maxLength ? text.substring(0, maxLength) + end : text;
}
export { truncate };
